"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMergedCalculatorState = void 0;
const react_1 = require("react");
const isRootParams_1 = require("../util/isRootParams");
const useMergedCalculatorState = (initialState) => {
    const [state, setState] = (0, react_1.useState)(initialState);
    const setMergedCalculatorState = (0, react_1.useCallback)((newState, isComparison, fuelIndex) => {
        if (fuelIndex === undefined) {
            setState((prevState) => {
                return { ...prevState, ...newState };
            });
        }
        else {
            setState((prevState) => {
                if (!prevState || !(0, isRootParams_1.isRootParams)(prevState)) {
                    return prevState;
                }
                let prevFuels = isComparison
                    ? prevState?.comparison_fuels ?? []
                    : prevState.fuels ?? [];
                const fuelsLength = Math.max(prevFuels.length, fuelIndex + 1);
                const newFuels = [...Array(fuelsLength)].map((_u, i) => i === fuelIndex
                    ? {
                        ...(prevFuels[i] ?? {}),
                        ...newState,
                    }
                    : prevFuels[i]);
                const key = isComparison
                    ? "comparison_fuels"
                    : "fuels";
                return {
                    ...prevState,
                    [key]: newFuels,
                };
            });
        }
    }, []);
    const removeFuel = (0, react_1.useCallback)((comparison, index) => {
        setState((prevState) => {
            if (!prevState ||
                !(0, isRootParams_1.isRootParams)(prevState) ||
                (comparison && !prevState.comparison_fuels) ||
                (!comparison && !prevState.fuels)) {
                return prevState;
            }
            console.info(`Removing ${comparison ? "comparison " : ""}fuel`, index);
            return {
                ...prevState,
                fuels: comparison
                    ? prevState.fuels
                    : prevState.fuels.filter((_f, i) => i !== index),
                comparison_fuels: comparison
                    ? prevState.comparison_fuels.filter((_f, i) => i !== index)
                    : prevState.comparison_fuels,
            };
        });
    }, []);
    return [state, setMergedCalculatorState, removeFuel];
};
exports.useMergedCalculatorState = useMergedCalculatorState;
